(function () {
  'use strict';

  // ---- formatMoney: matches Shopify's money_format token expansion ----
  function formatMoney(cents, format) {
    if (!format) format = '${{amount}}';
    var value = cents / 100;
    function fmt(num, precision, thousands, decimal) {
      if (isNaN(num) || num == null) return '0';
      precision = precision != null ? precision : 2;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var parts = num.toFixed(precision).split('.');
      var int = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousands);
      var dec = parts[1] ? decimal + parts[1] : '';
      return int + dec;
    }
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, fmt(value, 2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, fmt(value, 0))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, fmt(value, 2, '.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, fmt(value, 0, '.', ','))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, fmt(value, 2, "'", '.'));
  }

  // ---- Parse a rendered price string ("$322.99", "€289,99 EUR", "£249") to cents ----
  function parsePriceString(str) {
    if (!str) return null;
    // Strip currency, keep digits + first decimal/thousands separator
    var raw = str.replace(/[^\d.,-]/g, '').trim();
    if (!raw) return null;
    // Determine which is the decimal separator by position of last . vs ,
    var lastDot = raw.lastIndexOf('.');
    var lastComma = raw.lastIndexOf(',');
    var decimal;
    if (lastDot === -1 && lastComma === -1) {
      // No separator → integer dollars
      return parseInt(raw, 10) * 100;
    } else if (lastDot > lastComma) {
      decimal = '.';
      raw = raw.replace(/,/g, '');
    } else {
      decimal = ',';
      raw = raw.replace(/\./g, '').replace(',', '.');
    }
    var num = parseFloat(raw);
    if (isNaN(num)) return null;
    return Math.round(num * 100);
  }

  function updateAll(priceCents) {
    if (priceCents == null) return;
    document.querySelectorAll('[data-chiputt-per-month]').forEach(function (root) {
      var target = root.querySelector('[data-per-month-value]');
      if (!target) return;
      var months = parseInt(root.getAttribute('data-months'), 10) || 6;
      var format = root.getAttribute('data-money-format');
      var perMonth = Math.round(priceCents / months);
      target.textContent = formatMoney(perMonth, format);
    });
  }

  function readPriceFromDom() {
    // Theme renders the current price into [data-product-price] (matches snippets/product.liquid)
    var el = document.querySelector('[data-product-price]');
    if (el) return parsePriceString(el.textContent);
    // Fallback: try [data-selected-variant] script payload
    var jsonEl = document.querySelector('[data-selected-variant]');
    if (jsonEl) {
      try {
        var v = JSON.parse(jsonEl.textContent);
        if (typeof v.price === 'number') return v.price;
        if (typeof v.price === 'string') return Math.round(parseFloat(v.price) * 100);
      } catch (e) {}
    }
    return null;
  }

  function refresh() {
    var cents = readPriceFromDom();
    if (cents != null) updateAll(cents);
  }

  function init() {
    if (!document.querySelector('[data-chiputt-per-month]')) return;
    refresh();

    // 1) Hook into the theme's pub-sub (Shaper/Symmetry-style theme)
    //    PUB_SUB_EVENTS.optionValueSelectionChange fires when a variant option changes
    if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS) {
      window.subscribe(window.theme.PUB_SUB_EVENTS.optionValueSelectionChange, function () {
        // Theme takes ~1 tick to fetch + update the price node — re-read shortly after
        setTimeout(refresh, 150);
        setTimeout(refresh, 600);
      });
      if (window.theme.PUB_SUB_EVENTS.variantChange) {
        window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function () {
          setTimeout(refresh, 50);
        });
      }
    }

    // 2) MutationObserver on the price element — catches updates regardless of how the theme triggers them
    var priceEl = document.querySelector('[data-product-price]');
    if (priceEl && 'MutationObserver' in window) {
      new MutationObserver(refresh).observe(priceEl, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    // 3) Fallback: native change event on the variant select (covers themes that re-render via form submit)
    document.addEventListener('change', function (evt) {
      if (evt.target.matches('select[name="id"], input[name="id"]')) {
        setTimeout(refresh, 150);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
